import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Checkbox } from "@/components/ui/checkbox";
import { Library, Plus } from "lucide-react";
import { fmtTL } from "@/lib/utils";

export function CatalogPicker({ onPick }) {
  const [q, setQ] = useState("");
  const [sio, setSio] = useState(true);
  const [rows, setRows] = useState([]);
  useEffect(() => {
    if (q.trim().length < 2) { setRows([]); return; }
    const t = setTimeout(async () => {
      const get = (cid) => api.get("/item-groups/items", { params: { q }, headers: cid ? { "X-Company-Id": cid } : {} })
        .then(r => r.data.map(x => ({ ...x, src: cid ? "SİO" : "TKC" }))).catch(() => []);
      const [own, other] = await Promise.all([get(null), sio ? get("sio") : Promise.resolve([])]);
      setRows([...own, ...other].slice(0, 40));
    }, 300);
    return () => clearTimeout(t);
  }, [q, sio]);

  return (
    <div className="rounded-lg border border-dashed border-amber-500/50 p-3" data-testid="catalog-picker">
      <div className="flex items-center gap-3">
        <Library className="w-4 h-4 text-amber-600 shrink-0" />
        <Input value={q} onChange={e => setQ(e.target.value)} placeholder="İş Kalemleri kataloğunda ara (en az 2 harf)…" className="h-8" data-testid="catalog-search" />
        <label className="flex items-center gap-1.5 text-xs whitespace-nowrap"><Checkbox checked={sio} onCheckedChange={v => setSio(!!v)} data-testid="catalog-include-sio" /> SİO kataloğu da</label>
      </div>
      {rows.length > 0 && (
        <div className="mt-2 max-h-56 overflow-y-auto divide-y divide-border" data-testid="catalog-results">
          {rows.map((r, i) => (
            <button key={`${r.src}-${r.key}-${r.unit}`} type="button" onClick={() => onPick({ name: r.label.replace(/_x000D_/g, "").trim(), unit: r.unit, unit_price: r.avg })}
              className="w-full flex items-center gap-3 py-1.5 text-left text-sm hover:bg-muted/50 px-1" data-testid={`catalog-item-${i}`}>
              <Plus className="w-3.5 h-3.5 text-amber-600" />
              <span className="flex-1">{r.label.replace(/_x000D_/g, "")} <span className="text-xs text-muted-foreground">({r.unit})</span></span>
              <span className="text-[10px] px-1.5 rounded bg-muted">{r.src}</span>
              <span className="text-xs font-mono-nums" title={`min ${fmtTL(r.min)} – max ${fmtTL(r.max)}`}>ort. {fmtTL(r.avg)}</span>
            </button>
          ))}
        </div>
      )}
      {q.trim().length >= 2 && rows.length === 0 && <div className="text-xs text-muted-foreground mt-2">Katalogda eşleşen kalem yok; aşağıdan elle ekleyebilirsiniz.</div>}
    </div>
  );
}
